import { Customer } from "../../models/customer/customer";
import { setCustomerDetailsAction, setCustomerWaitlistStateAction } from "./actionTypes"

export const setCustomerDetails = (data: Customer) => ({type: setCustomerDetailsAction, payload: data})

export const setCustomerWaitlistState = (isInWaitlist: Boolean) => ({ type: setCustomerWaitlistStateAction, payload: isInWaitlist })
